import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=279be285&"
import script from "./UserProfile.vue?vue&type=script&lang=js&"
export * from "./UserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\invoiceasy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('279be285')) {
      api.createRecord('279be285', component.options)
    } else {
      api.reload('279be285', component.options)
    }
    module.hot.accept("./UserProfile.vue?vue&type=template&id=279be285&", function () {
      api.rerender('279be285', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/UserProfile.vue"
export default component.exports